(function () {
  'use strict';
  const lastText = new WeakMap();
  let scheduled = false;
  function localise(raw) {
    if (!raw || !globalThis.SSUiText) return raw;
    const match = raw.match(/^(\s*)([\s\S]*?)(\s*)$/);
    const body = match[2], required = body.match(/^(.*?)(\s*\*)$/);
    const source = required ? required[1] : body;
    const target = globalThis.SSUiText(source);
    return match[1] + target + (required ? required[2] : '') + match[3];
  }
  function translateForms() {
    scheduled = false;
    for (const form of document.querySelectorAll('.globo-formbuilder')) {
      const walker = document.createTreeWalker(form, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement?.closest('script,style,textarea,[contenteditable]')) continue;
        if (lastText.get(node) === node.nodeValue) continue;
        const value = localise(node.nodeValue);
        if (value !== node.nodeValue) node.nodeValue = value;
        lastText.set(node, value);
      }
      for (const el of form.querySelectorAll('[placeholder],[aria-label],[title]')) {
        for (const name of ['placeholder', 'aria-label', 'title']) {
          const value = el.getAttribute(name);
          if (value === null) continue;
          const target = localise(value);
          if (target !== value) el.setAttribute(name, target);
        }
      }
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(translateForms);
  }
  function init() {
    if (!document.body) return;
    translateForms();
    new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true, characterData:true});
    document.addEventListener('shopify:section:load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
